import { Applicant } from '../../../providers/api/dtos/applicant';
import { UpdateApplicantFormModel } from './UpdateApplicantForm';

export const updateApplicantFormModalToApplicant = (values: UpdateApplicantFormModel, applicant: Applicant): Applicant => ({
  ...applicant,
  name: values.name.trim(),
  phoneNumber: values.phoneNumber.trim() || undefined,
  email: values.email.trim() || undefined,
  linkedIn: values.linkedIn.trim() || undefined,
});

export const applicantToUpdateApplicantFormModel = (applicant: Applicant): UpdateApplicantFormModel => ({
  name: applicant.name,
  phoneNumber: applicant.phoneNumber || '',
  email: applicant.email || '',
  linkedIn: applicant.linkedIn || '',
});
